export enum LeanType {
  None = 'none',
  LeanOnly = 'lean-only',
  LeanWithStorage = 'lean-with-storage',
}
